import { render, staticRenderFns } from "./payment-method-selection.component.vue?vue&type=template&id=7f23e1d9&scoped=true&"
import script from "./payment-method-selection.component.vue?vue&type=script&lang=ts&"
export * from "./payment-method-selection.component.vue?vue&type=script&lang=ts&"
import style0 from "./payment-method-selection.component.vue?vue&type=style&index=0&id=7f23e1d9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23e1d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
